angular
.module('ExclusionsCtrl', [])
.controller('ExclusionsCtrl', function ($scope) {
  var tab = $scope.$parent.tab
  $scope.acct_number = tab.data && tab.data.brokerageAccountNumber
  $scope.drupal_env = Drupal.settings.environment
});
